import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  useFullAmount: true,
  fixedAmount: 1,
  fixedAmountScope: 'Both',
  ttlMinutes: 60,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('FORM_RESET')
    systemSettingApi.getPaymentSetting()
      .then(({ data }) => commit('PAYMENT_SETTING_FETCHED', data))
      .catch(err => commit('PAYMENT_SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updatePaymentSetting(state)
      .then(({ data }) => commit('PAYMENT_SETTING_UPDATED', data))
      .catch(error => {
        commit('PAYMENT_SETTING_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  PAYMENT_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
  },
  PAYMENT_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  PAYMENT_SETTING_FETCH_FAILED() {
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  PAYMENT_SETTING_FETCHED(state, data) {
    Object.assign(state, data)
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
